import Seo from "@/components/Seo";
import Marquee from "@/components/Marquee";
import Hero, { TrustStrip } from "@/components/home/Hero";
import Story from "@/components/home/Story";
import FeaturedCollections from "@/components/home/FeaturedCollections";
import Signature from "@/components/home/Signature";
import Bridal from "@/components/home/Bridal";
import { CustomJewellery, Difference } from "@/components/home/Custom";
import Occasions from "@/components/home/Occasions";
import { Knowledge, Reviews, InstagramSection, VisitShowroom, ConsultationCTA } from "@/components/home/Editorial";
import { BRAND_FULL, ADDRESS, PHONE_DISPLAY } from "@/config/site";

const jsonLd = {
    "@context": "https://schema.org",
    "@type": "JewelryStore",
    name: "BSK Jewellers",
    alternateName: BRAND_FULL,
    address: {
        "@type": "PostalAddress",
        streetAddress: "Rani Ka Bagh",
        addressLocality: "Amritsar",
        addressRegion: "Punjab",
        addressCountry: "IN",
    },
    telephone: PHONE_DISPLAY,
};

const Home = () => (
    <main>
        <Seo
            title="BSK Jewellers — Luxury Gold, Diamond & Bridal Jewellery in Amritsar"
            siteName="BSK Jewellers"
            description={`BSK Jewellers (${BRAND_FULL}) — a premium jewellery house in ${ADDRESS}. Explore gold, diamond and bridal collections, book a private consultation, visit our showroom.`}
            image="/images/hero-new.jpg"
            jsonLd={jsonLd}
        />
        <Hero />
        <TrustStrip />
        <Story />
        <Marquee items={["Handcrafted in Amritsar", "Gold", "Diamond", "Bridal", "Bespoke", "Made to be Cherished"]} />
        <FeaturedCollections />
        <Signature />
        <Bridal />
        <CustomJewellery />
        <Difference />
        <Occasions />
        <Marquee items={["Crafted for the moments that matter", "Tradition meets contemporary elegance", "Designed for today — treasured forever"]} />
        <Knowledge />
        <Reviews />
        <InstagramSection />
        <VisitShowroom />
        <ConsultationCTA />
    </main>
);

export default Home;
